import { render, staticRenderFns } from "./OtherExpenseForm.vue?vue&type=template&id=6a7e155d"
import script from "./OtherExpenseForm.vue?vue&type=script&lang=js"
export * from "./OtherExpenseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports